import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class ScrollytellingWord {
    constructor() {
        this.container = document.querySelector('.js-scrollytelling-word');
        this.animationDistance = -100; // default value
    }

    getViewportDistance() {
        const viewportWidth = window.innerWidth;
        if (viewportWidth < 768) {
            return -35;
        } else if (viewportWidth >= 768 && viewportWidth <= 1024) {
            return -75;
        }
        return -100;
    }

    init() {
        if (this.container) {
            this.animationDistance = this.getViewportDistance();
            this.run();
        }
    }

    run() {
        gsap.registerPlugin(ScrollTrigger);

        // Get the elements we need to animate
        const headline = this.container.querySelector('.headline');
        const subline = this.container.querySelector('.subline');

        const wordContainer = this.container.querySelector('.word-container')
        const word = this.container.querySelector('.word');
        const copy = this.container.querySelector('.copy');

        gsap.set('.js-scrollytelling-word .has-primary-highlight', { backgroundSize: '0' });

        gsap.set(subline, { opacity: 0, scale: 0.5 });
        gsap.set(word, { opacity: 0, scale: 0.5 });
        gsap.set(copy, { opacity: 0, y: 30 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.container,
                //markers: true,
                start: 'top 80%',
                end: 'bottom 75%',
                scrub: 1
            }
        });

        // Animation sequence
        tl
            .to('.headline.has-primary-highlight', {
                backgroundSize: '100% 0.5em',
                duration: 0.8,
                ease: 'power1.inOut'
            })

            // Fade in and scale up the subline
            .to(subline, {
                opacity: 1,
                scale: 1,
                duration: 1,
                ease: 'power2.out'
            }, '+=0.5')

            .to('.subline.has-primary-highlight', {
                backgroundSize: '100% 0.5em',
                duration: 0.8,
                ease: 'power1.inOut'
            }, '+=0.5')

            // Fade in and scale up the word
            .to(word, {
                opacity: 1,
                duration: 1,
                ease: 'power2.out'
            }, '+=0.5')

            .to(subline, {
                opacity: 0,
                y: -50,
                duration: 1,
                ease: 'power1.in'
            }, '+=1')

            .to(wordContainer, {
                y: this.animationDistance,
                duration: 1.5,
                ease: 'power2.out'
            }, '>')

            .to(word, {
                scale: 2,
                duration: 0.5,
                ease: 'power2.out'
            }, '+=0.5')

            .to('.word.has-primary-highlight', {
                backgroundSize: '100% 0.5em',
                duration: 0.8,
                ease: 'power1.inOut'
            }, '<')

            // Fade in the copy text
            .to(copy, {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power1.out'
            }, '+=0.5');
    }
}

export default new ScrollytellingWord(); 
